if (!customElements.get('wta-mobile-acquisition')) {
  customElements.define(
    'wta-mobile-acquisition',
    class extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewportChange = () => {
          this.observer?.disconnect();
          this.observer = null;
          this.hidden = true;

          if (!this.mobileQuery.matches) return;

          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.hidden = entry.isIntersecting;
            },
            { threshold: 0.08 },
          );
          this.observer.observe(this.target);
        };

        this.mobileQuery.addEventListener('change', this.handleViewportChange);
        this.handleViewportChange();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
      }
    },
  );
}
